<template>
    <div class="quantity">
        <div class="quantityNav">
            <button type="button" :disabled="!subAllowed" @click="sub" class="quantityButton quantity-down">-</button>
        </div>
        <input type="number" :min="min" :step="step" v-model="workingValue">
        <div class="quantityNav">
            <button type="button" :disabled="!addAllowed" @click="add" class="quantityButton quantity-up">+</button>
        </div>
    </div>

</template>

<script>
export default {
    name: "Quantity",
    props: {
        min: {
            required: false,
            type: Number,
            default: 0
        },
        step: {
            required: false,
            type: Number,
            default: 1,
        },
        value: {
            required: true,
            type: Number,
        }
    },
    computed: {
        addAllowed() {
            return true;
        },
        subAllowed() {
            return (this.workingValue - this.step >= this.min);
        },
        workingValue: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', parseInt(value));
            }
        }
    },
    methods: {
        add() {
            if (this.addAllowed) {
                this.workingValue = this.workingValue + this.step;
            }
        },
        sub() {
            if (this.subAllowed) {
                this.workingValue = this.workingValue - this.step;
            }
        }
    }
}
</script>

<style scoped>

</style>
